import { createSelector } from '@reduxjs/toolkit';

import { getRelationshipDomainsAndRanges } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/getRelationshipDomainsAndRanges';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectClassHierarchySelector } from 'src/selectors/projectClassHierarchy';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';

export const projectRelationshipDomainAndRangesSelector =
  memoizeSelectorFactory((projectId: string, relationshipIri: string) =>
    createSelector(projectLinkDataArraySelector(projectId), (linkDataArray) =>
      getRelationshipDomainsAndRanges(linkDataArray, relationshipIri)
    )
  );

export const projectRelationshipHierarchicalDomainAndRangesSelector =
  memoizeSelectorFactory((projectId: string, relationshipIri: string) =>
    createSelector(
      projectRelationshipDomainAndRangesSelector(projectId, relationshipIri),
      projectClassHierarchySelector(projectId),
      ({ domains: oldDomains, ranges: oldRanges }, classHierarchyByIri) => {
        const domains = new Set(oldDomains);
        const ranges = new Set(oldRanges);

        oldDomains.forEach((domain) => {
          const hierarchy = classHierarchyByIri[domain];
          Object.keys(hierarchy.descendants).forEach((klass) => {
            domains.add(klass);
          });
        });
        oldRanges.forEach((range) => {
          const hierarchy = classHierarchyByIri[range];
          Object.keys(hierarchy.descendants).forEach((klass) => {
            ranges.add(klass);
          });
        });

        return { domains, ranges };
      }
    )
  );
